import React, { useState, useRef, useEffect } from "react";
import styles from "./styles";
import { connect } from "react-redux";
import {
    Container,
    Input,
    Button,
    InputAdornment,
    IconButton,
    Typography,
} from "@material-ui/core";
import ArchivosSubidos from "../ArchivosSubidos/ArchivosSubidos";
import uploadIcono from "../../../assets/iconos/upload-icon.png";
import SearchIcon from "@material-ui/icons/Search";
import DeleteIcon from "@material-ui/icons/Delete";
import * as actionsPresentacion from "../../../actions/nuevaPresentacion";
import * as actionsVentanaDialogo from "../../../actions/ventanaDialogo";
import { TextFieldCustom } from "../../common/UI/Personalizaciones/TextField";

const InternacionCargada = (props) => {
    const classes = styles();
    const inputAdjuntar = useRef();
    const extensionesAceptadas = ".jpg,jpeg,.png,.pdf";
    const [nroInternacionValue, setNroIntValue] = useState(
        props.internacion.nroInternacion
    );
    
    useEffect(() => {
        setNroIntValue(props.internacion.nroInternacion);
    }, [props.internacion.nroInternacion]);

    const filtrarArchivosPorExtension = (archivos) => {
        const archivosFiltrados = archivos.filter((archivo) => {
            const extensiones = extensionesAceptadas.split(",");
            let arcValido = false;

            for (let i = 0; i < extensiones.length; i++) {
                const extension = extensiones[i];

                if (
                    archivo.name.toLowerCase().endsWith(extension) &&
                    !props.internacion.detalles.some(
                        (arch) =>
                            arch.nombreArchivo === archivo.name &&
                            !arch.bajaLogica
                    )
                ) {
                    arcValido = true;
                    break;
                }
            }

            return arcValido;
        });

        return archivosFiltrados;
    };

    const propcesarSubidaArchivos = (archivos, index) => {
        const archivosFiltrados = filtrarArchivosPorExtension([...archivos]);

        if (archivosFiltrados.length > 0) {
            props.cargarArchivosInternacionHandler(archivosFiltrados, index);
        } else {
            const ventanaConfig = {
                estaVisible: true,
                titulo: "Error al procesar archivos",
                mensaje:
                    "No se procesó ninguno de los archivos seleccionados, ya que no cumplen con las extensiones soportadas [*.jpg,*.jpeg,*.png,*.pdf] o se encuentran repetidos",
                esAlerta: true,
                clickAceptar: () =>
                    props.actualizarAtriutoVentanaDialogo({
                        estaVisible: false,
                    }),
            };

            props.actualizarAtriutoVentanaDialogo(ventanaConfig);
        }
    };

    const controlNroInternacionNoRepetido = (nroInternacion) => {
        let esValido = true;

        for (let i = 0; i < props.internaciones.length; i++) {
            const internacion = props.internaciones[i];

            if (
                parseInt(nroInternacion) === parseInt(internacion.nroInternacion) &&
                !internacion.bajaLogica
            ) {
                esValido = false;
                break;
            }
        }

        return esValido;
    };

    const mostrarBtnHabilitado = (habilitado) => {
        if (!habilitado) {
            inputAdjuntar.current.className =
                inputAdjuntar.current.className + " Mui-disabled";
        } else {
            inputAdjuntar.current.className = inputAdjuntar.current.className.replace(
                "Mui-disabled",
                ""
            );
        }
    };

    const buscarInformacion = (index, nroInternacion) => {
        setNroIntValue(nroInternacion);
        const esValido = controlNroInternacionNoRepetido(nroInternacion);

        if (nroInternacion === "") {
            props.actualizarMensajesError(
                "nroInternacion" + index,
                `Ingrese ${props.idPresentacion===3?"DNI de socio":"Nº internación"}`
            );
            props.actualizarRequeridosEsValido("internaciones", false);
            mostrarBtnHabilitado(false);
        } else if (esValido) {
            props.actualizarNroInternacionHandler(index, nroInternacion);
            props.actualizarMensajesError("nroInternacion" + index, null);
            mostrarBtnHabilitado(true);
        } else {
            props.actualizarNroInternacionHandler(index, nroInternacion);
            props.actualizarMensajesError(
                "nroInternacion" + index,
                `${props.idPresentacion===3?"DNI de socio":"Nº de internación"} repetido`
            );
            mostrarBtnHabilitado(false);
            props.actualizarRequeridosEsValido("internaciones", false);
        }
    };

    const filtrarCaracteresCampoNumerico = (event) => {
        if (event.key.toLowerCase() === "e" || event.key === ".") {
            event.preventDefault();
        }
    };

    const mostrarAdjuntarArchivos = () => {
        if (props.deshabilitado) {
            return null;
        }

        return (
            <Button
                variant="outlined"
                component="label"
                className={classes.btnAdjuntar}
                ref={inputAdjuntar}
            >
                <Input
                    id={"icon-button-file-" + props.index}
                    type="file"
                    onChange={(event) =>
                        propcesarSubidaArchivos(event.target.files, props.index)
                    }
                    inputProps={{
                        accept: extensionesAceptadas,
                        multiple: true,
                        hidden: true,
                    }}
                />
                <img
                    src={uploadIcono}
                    alt="Subir archivo"
                    className={classes.iconoUpload}
                />
                Elegí un archivo
            </Button>
        );
    };

    const mostrarBtnBorrar = () => {
        if (props.deshabilitado) {
            return null;
        }

        return (
            <IconButton
                size="small"
                onClick={() => props.indexBorradoHandler(props.index)}
                disabled={props.deshabilitado}
                className={classes.containerAlineado}
            >
                <DeleteIcon fontSize="small" />
            </IconButton>
        );
    };

    const mostrarInputNombreApellido = () => {
        if (
            !props.internacion.nombreCompleto ||
            props.internacion.nombreCompleto === ""
        ) {
            return (
                <div className={classes.containerNroInvalido}>
                    <Typography className={classes.nroInvalido} color="error">
                        Asociado no encontrado
                    </Typography>
                </div>
            );
        }

        return (
            <TextFieldCustom
                label="Nombre y apellido"
                variant="outlined"
                size="small"
                className={classes.nombreSocio}
                disabled={props.esEdicion}
                inputProps={{ readOnly: props.soloVista }}
                value={
                    props.internacion.nombreCompleto
                        ? props.internacion.nombreCompleto
                        : ""
                }
            />
        );
    };

    if (props.internacion.bajaLogica) {
        return null;
    }

    let archivosCargados = null;
    if (props.internacion.detalles.length > 0) {
        archivosCargados = (
            <ArchivosSubidos
                fileInfos={props.internacion.detalles}
                borrarArchivos={(pathFile) =>
                    props.eliminarArchivoInternacionHandler(
                        props.index,
                        pathFile
                    )
                }
                deshabilitado={props.deshabilitado}
            />
        );
    }

    return (
        <>
            <Container disableGutters={true} className={classes.container}>
                {mostrarBtnBorrar()}
                <TextFieldCustom
                    label={`${props.idPresentacion===3?"DNI de socio":"Nº socio"}`}
                    variant="outlined"
                    size="small"
                    type="number"
                    className={classes.nroInternacion}
                    value={nroInternacionValue ?? ""}
                    inputProps={{ readOnly: props.soloVista }}
                    onChange={(event) =>
                        buscarInformacion(props.index, event.target.value)
                    }
                    onKeyPress={(event) =>
                        filtrarCaracteresCampoNumerico(event)
                    }
                    onBlur={(event) =>
                        props.actualizarInternacionHandler(props.index)
                    }
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                {!props.soloVista && (
                                    <IconButton size="small">
                                        <SearchIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </InputAdornment>
                        ),
                    }}
                    error={!!props.errorMensaje["nroInternacion" + props.index]}
                    helperText={
                        props.errorMensaje["nroInternacion" + props.index] &&
                        props.errorMensaje["nroInternacion" + props.index]
                    }
                />
                {mostrarInputNombreApellido()}
                {mostrarAdjuntarArchivos()}
            </Container>
            <Container
                disableGutters={true}
                className={classes.containerAdjuntos}
            >
                {archivosCargados}
            </Container>
        </>
    );
};

const mapStateToProps = (state) => ({
    internaciones: state.nuevaPresentacionReducer.internaciones,
    esEdicion: state.nuevaPresentacionReducer.esEdicion,
    soloVista: state.nuevaPresentacionReducer.soloVista,
    errorMensaje: state.nuevaPresentacionReducer.errorMensaje,
});

const actionCreators = {
    actualizarMensajesError: actionsPresentacion.actualizarMensajesError,
    actualizarRequeridosEsValido:
        actionsPresentacion.actualizarRequeridosEsValido,
    actualizarAtriutoVentanaDialogo:
        actionsVentanaDialogo.actualizarAtriutoVentanaDialogo,
};

export default connect(mapStateToProps, actionCreators)(InternacionCargada);
